import { first } from 'rxjs/operators';
import { InboxService, Inbox } from '@app/_components/inbox';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InboxComponent } from '../inbox/inbox.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, AuthenticationService } from '@app/_services';
import {LazyLoadEvent, MessageService, ConfirmationService, FilterService, MenuItem, TreeNode, SelectItem} from 'primeng/api';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import {TaskComponent} from '@app/_components/task/task/task.component';
import {ImapUserMappingService} from '@app/_components/imap-user-mapping/imap-user-mapping.service';
import {ImapConfigurationService} from '@app/_components/imap-configuration/imap-configuration.service';
import {Msg, MsgService} from '@app/_components/msg';
import {TaskListComponent} from '@app/_components/task/task-list/task-list.component';

@Component({
    selector: 'app-inbox-list',
    templateUrl: './inbox-list.component.html',
    styleUrls: ['./inbox-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class InboxListComponent implements OnInit {
	cols: { field: string; header: string; }[];
	tableData: any[] = [];
	allInboxes: any;
	childInboxesData: any;
	currentUser: User;
	currentUserSubscription: Subscription;
  mailBoxes: SelectItem[];
  selectedmailbox = '3';
  selectedNode: TreeNode;
  items: MenuItem[];
  mailBoxIds: any[];
  private inobxes: any[];
  msg: Msg;

  constructor(
		private inboxService: InboxService,
		private imapConfigurationService: ImapConfigurationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private authenticationService: AuthenticationService,
		private dialog: MatDialog,
		public datePipe: DatePipe,
    private msgService: MsgService
	) {
		this.statuses = inboxService.statuses;
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
		});
		try {
      this.mailBoxes = [];

      this.mailBoxes.push({ label: 'Inbox', icon: 'pi pi-envelope', styleClass: 'p-button-info', value: '3' });
      this.mailBoxes.push({ label: 'Sentbox', icon: 'pi pi-telegram', styleClass: 'p-button-info',  value: '2' });
      this.mailBoxes.push({ label: 'Outbox', icon: 'pi pi-exclamation-triangle', styleClass: 'p-button-info', value: '5' });
      this.mailBoxes.push({ label: 'Archived', icon: 'pi pi-arrow-circle-down', styleClass: 'p-button-info', value: '0' });

		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}

    this.imapConfigurationService.findAllByUserId(this.currentUser.userId)
      .subscribe(
        res => {

          let permissions = res.data.imapConfiguration;
          this.inboxNames = [];
          this.mailBoxIds = [];
          for ( let j = 0; j < permissions.length; j++) {
            this.inboxNames[j] = permissions[j];
            this.mailBoxIds.push(permissions[j].imapConfigurationId);
          }
          this.loadLazy(this.lazyLoadEvent);
          console.log(this.inboxNames);
        },
        err => {
          console.log('Feature-Update FAIL: ' + JSON.stringify(err));
        },
        () => { });
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	inboxs: any[] = [];
	parents: any[] = [];
	children: any[] = [];
	inbox: Inbox;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	inboxNames: any;
	columns: any[] = [
		// { field: 'msgId', header: 'Id', width: 'auto' },
		{ field: 'inboxName', header: 'Inbox Name', width: '350px' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'senderName', header: 'Sender Name', width: 'auto' },
		{ field: 'senderEmail', header: 'Sender Email', width: 'auto' },
		{ field: 'subject', header: 'subject', width: 'auto' },
		{ field: 'receivedDate', header: 'Received Date', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'receivedDate', order: 1 });

      this.items = [
        {
          label: 'Assign Task',
          icon: 'pi pi-fw pi-plus',
          command: (event) => this.openCreatTask(this.selectedNode.data)
        },
        {
          separator: true
        },
        {
          label: 'Archive',
          icon: 'pi pi-fw pi-download',
          command: (event) => this.archiveMsg(this.selectedNode.data)
        }
      ];

		}
		catch (error) {
			console.log('Error: ' + error);
		}

	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.inboxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			event.filters['parentMsgId'] = {};
			event.filters['parentMsgId'].value = 0;
			event.filters['parentMsgId'].matchMode = 'in';

      event.filters['msgFolder'] = {};
      event.filters['msgFolder'].matchMode = 'in';
      if ( '0' === this.selectedmailbox){
        this.lazyLoadEvent.filters['msgFolder'].value = 2;
        this.selectedmailbox = '';
      }
      else{
        this.lazyLoadEvent.filters['msgFolder'].value = 0;
      }
      event.filters['status'] = {};
      event.filters['status'].value = this.selectedmailbox;
      event.filters['status'].matchMode = 'in';

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-inbox-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'receivedDate', order: -1 });
			}
      if (!this.mailBoxIds || this.mailBoxIds.length <= 0){
        this.loading = false;
        return;
      }
      if ( !(event.filters['ImapConfigurationVO.imapConfigurationId']?.value && event.filters['ImapConfigurationVO.imapConfigurationId']?.value.length > 0) ) {
        let emailFilter = { 'ImapConfigurationVO.imapConfigurationId': { 'value': this.mailBoxIds, 'matchMode': 'in' } };
        Object.assign(event.filters, emailFilter);
      }
			const pageNumber = Math.round(event.first / event.rows);
			this.inboxService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.inboxs = [];
						this.inbox = res.data.msgs;
						this.allInboxes = res.data.msgs;
						for (let i = 0; i < res.data.msgs.length; i++) {
								let node = {
									data: {
										msgId: res.data.msgs[i].msgId,
										inboxName: res.data.msgs[i].imapConfigurationAPI.name,
										status: this.getStatusName(res.data.msgs[i]),
										senderName: res.data.msgs[i].senderName,
										senderEmail: res.data.msgs[i].senderEmail,
										subject: res.data.msgs[i].subject,
										receivedDate: this.datePipe.transform(res.data.msgs[i].receivedDate, 'MMM d, y, h:mm:ss a'),
										emailHtml: res.data.msgs[i].emailHtml,
										emailText: res.data.msgs[i].emailText,
										mobileText: res.data.msgs[i].mobileText,
										sentDate: res.data.msgs[i].sentDate,
										topic: res.data.msgs[i].topic,
										msgRecipientAPIList: res.data.msgs[i].msgRecipientAPIList,
										campaignVars: res.data.msgs[i].campaignVars,
										headers: res.data.msgs[i].headers,
										imapConfigId: res.data.msgs[i].imapConfigurationAPI.imapConfigurationId,
										imapConfigurationAPI: res.data.msgs[i].imapConfigurationAPI,
										taskAPI: res.data.msgs[i].taskAPI,
										msgFolder: res.data.msgs[i].msgFolder,
										taskAPIList: res.data.msgs[i].taskAPIList,
                    parentMsgId: res.data.msgs[i].parentMsgId,
                    jsonChildMsg: res.data.msgs[i].jsonChildMsg,
									},
									leaf: false
								};
								this.inboxs.push(node);
						}
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.inboxs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
      this.loading = false;
		}
	}
	onNodeExpand(event: any) {
		const node = event.node;
		const childInboxes = [];
		this.inboxService.findChildMails(node.data.msgId).pipe(first()).subscribe(
			(res: any) => {
				this.childInboxesData = res.data.msgs;
				for (let i = 0; i < this.childInboxesData.length; i++) {
          let imapConfId = '', imapConfName = '';
          if ( res.data.msgs[i].imapConfigurationAPI){
            imapConfId = res.data.msgs[i].imapConfigurationAPI.imapConfigurationId;
            imapConfName = this.childInboxesData[i].imapConfigurationAPI.name;
          }
					let node = {
						data: {
							msgId: this.childInboxesData[i].msgId,
							inboxName: imapConfName,
							status: this.getStatusName(this.childInboxesData[i]),
							senderName: this.childInboxesData[i].senderName,
							senderEmail: this.childInboxesData[i].senderEmail,
							subject: this.childInboxesData[i].subject,
							receivedDate: this.datePipe.transform(this.childInboxesData[i].receivedDate, 'MMM d, y, h:mm:ss a'),
							emailHtml: this.childInboxesData[i].emailHtml,
							imapConfigId: imapConfId,
              taskAPIList: this.childInboxesData[i].taskAPIList,
              ischild: true
						},
					};
					childInboxes.push(node);
				}
				node.children = childInboxes;
				this.inboxs = [...this.inboxs];
			},
			(err: any) => {
				console.log('reviews list error!: ' + JSON.stringify(err));
				this.alertService.error(err);
			},
			() => { this.loading = false; }
		);
	}
	getStatus() {
		return;
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(inbox: Inbox) {
		try {
			this.formLoading = true;
			this.inboxService.update(inbox)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.inboxs.map((inbox, i) => {
							if (inbox.msgId === res.data.msg.msgId) {
								this.inboxs[i] = res.data.inbox;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(inbox: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(inbox));

			this.formLoading = true;
			this.inboxService.delete(inbox.inboxId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.inboxs.splice(this.inboxs.indexOf(inbox), 1);
						this.recordTotal = this.inboxs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Inbox ' + inbox.inboxId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Inbox ' + inbox.inboxId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
  sendOutBoxMails() {
    try {
      this.formLoading = true;
      this.inboxService.sendOutboxMails()
        .subscribe(
          (res: any) => {
            console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
            // this.alertService.success(res, true);
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.loadLazy(this.lazyLoadEvent);
            this.formLoading = false;
          },
          (err: any) => {
            // Do NOT reset formLoading on error — a 504 means outbox mail may have been sent.
            // Keep button disabled to prevent duplicate sends.
            console.log('sendOutBoxMails FAIL: ' + JSON.stringify(err));
            this.alertService.error(JSON.stringify(err));
          },
          () => {});
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }
	refreshMails() {
		try {
			this.formLoading = true;
			this.inboxService.refresh()
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.loadLazy(this.lazyLoadEvent);
						this.formLoading = false;
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(JSON.stringify(err));
						this.formLoading = false;
					},
					() => {});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
			this.formLoading = false;
		}
	}
	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'New Mail',
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(inbox: Inbox) {

		const dialogConfig = new MatDialogConfig();
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			inbox: inbox,
			title: 'View Inbox Mail'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateInboxCB(data);
        this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
		dialogRef.componentInstance.doUpdateAndDontClose.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.loadLazy(this.lazyLoadEvent);

			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteInboxCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addInboxCB(inbox: Inbox) {
		console.log('Adding Inbox: ' + JSON.stringify(inbox));
		// if we don't have a inboxs array yet...
		if (!this.inboxs) {
			this.inboxs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.inboxs.unshift(inbox);

		// no idea what this is but it is required to update the array
		this.inboxs = [...this.inboxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Added', life: 3000 });
	}

	updateInboxCB(inbox: Inbox) {
		console.log('Updating Inbox: ' + JSON.stringify(inbox));
		let itemIndex = this.inboxs.findIndex((item: any) => item.inboxId === inbox.msgId);
		this.inboxs[itemIndex] = inbox;

		// no idea what this is but it is required to update the array
		this.inboxs = [...this.inboxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Updated', life: 3000 });
	}

	deleteInboxCB(inbox: Inbox) {
		console.log('Removing Inbox: ' + inbox);
		this.inboxs.splice(this.inboxs.indexOf(inbox), 1);
		this.recordTotal = this.inboxs.length;

		// no idea what this is but it is required to update the array
		this.inboxs = [...this.inboxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.inboxs ? this.first === (this.inboxs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.inboxs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(inbox: any) {
		if (inbox?.status) {
			const status = this.statuses.find((e: any) => e.value == inbox.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator() {
		return true;
	}

  loadMailBox(event: any) {
    this.loadLazy(this.lazyLoadEvent);
  }

  private openCreatTask(selectedNode: any) {
    const dialogConfig = new MatDialogConfig();

	  // settings
	  dialogConfig.width = '100vw';
	  dialogConfig.height = '100vh';
	  dialogConfig.maxWidth = '100vw';
	  dialogConfig.maxHeight = '100vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    let custTaskApi = {name: selectedNode.subject};
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      action: 'create',
	 purpose: 'createmailtask',
      taskApi: custTaskApi,
	  msg: selectedNode as Msg
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        dialogRef.close();
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        this.messageService.add({
          severity: 'success',
          summary: 'Task Created',
          detail: 'Task Created',
        });
        this.loadLazy(this.lazyLoadEvent);
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        dialogRef.close();
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        this.messageService.add({
          severity: 'success',
          summary: 'Task Created',
          detail: 'Task Created',
        });
        this.loadLazy(this.lazyLoadEvent);
        dialogRef.close();
      });
  }

  private archiveMsg(selectedNode: TreeNode) {
    try {
      let msg  =  new Msg();
      let sel = selectedNode as object;
      // @ts-ignore
      msg.msgId = sel?.msgId;
      msg.msgFolder = 2;  // 2 is for archive folder
      this.msgService.archiveMsg(msg).subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Archived',
            detail: res.message,
          });
          this.loadLazy(this.lazyLoadEvent);
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
        }
      );
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  getFilteredTags(tags) {
    // if filter text input is empty then load all records
    if (tags == '0') {
      delete this.lazyLoadEvent.filters.msgId;
      this.loadLazy(this.lazyLoadEvent);
    } else {
      // If records found then show filtered records
      if (tags.length > 0) {
        // if filter text input is not empty then load filtered records only
        let filteredMsgIds = [];
        tags.forEach(tag => {
          filteredMsgIds.push(tag.tagSourceId);
        });
        let activityProviderIdFilter = { 'msgId': { 'value': filteredMsgIds, 'matchMode': 'in' } };
        Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
        this.loadLazy(this.lazyLoadEvent);
      } else {
        // Display empty table as no record found with filtered input
        this.inobxes = [];
      }
    }
  }

	openViewTask(rowData: any) {
		if (rowData.taskAPIList?.length > 1) {
			const dialogConfig = new MatDialogConfig();
			// settings
			dialogConfig.width = '100%';
			dialogConfig.height = '100%';
			dialogConfig.maxWidth = '1600px';
			dialogConfig.maxHeight = '800px';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				title: 'Mail Tasks',
				isModal: true,
				parentMsgId: rowData.msgId,
				fromMail: true,
				showFilter: false,
				showPagination: false,
				outlineNewButton: false,
			};
			const dialogRef = this.dialog.open(TaskListComponent, dialogConfig);
		} else {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.width = '100vw';
			dialogConfig.height = '100vh';
			dialogConfig.maxWidth = '100vw';
			dialogConfig.maxHeight = '100vh';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.data = {
				title: 'Assign Task',
				isModal: true,
				taskApi: rowData?.taskAPIList[0],
				fromMail: false
			};

			const dialogRef = this.dialog.open(TaskComponent, dialogConfig);
			dialogRef.componentInstance.doAdd.subscribe(
				data => {
					console.log('Dialog output:', data);
					this.loadLazy(this.lazyLoadEvent);
					dialogRef.close();
				});
		}
	}

  getNumberOfChildMsg(msg: any) {
    if (!msg?.jsonChildMsg || '' === msg?.jsonChildMsg) {
      return 0;
    }
    return JSON.parse(msg?.jsonChildMsg).length;

  }
}
